import { DEFAULT_ATTACK, DEFAULT_DECAY, DEFAULT_RELEASE, DEFAULT_SUSTAIN, MIN_GAIN, type EnvelopeSpec } from "./constants";

export function applyEnvelope(
  gainParam: AudioParam,
  context: BaseAudioContext,
  partialEnvelope: Partial<EnvelopeSpec> = {}
): void {
  const envelope: EnvelopeSpec = {
    attack: DEFAULT_ATTACK,
    decay: DEFAULT_DECAY,
    sustain: DEFAULT_SUSTAIN,
    release: DEFAULT_RELEASE,
    peakGain: 0.45,
    ...partialEnvelope
  };
  const now = context.currentTime;
  const peakGain = Math.max(MIN_GAIN, envelope.peakGain);
  const sustainGain = Math.max(MIN_GAIN, peakGain * envelope.sustain);

  gainParam.cancelScheduledValues(now);
  gainParam.setValueAtTime(MIN_GAIN, now);
  gainParam.exponentialRampToValueAtTime(peakGain, now + Math.max(0.001, envelope.attack));
  gainParam.setTargetAtTime(sustainGain, now + envelope.attack, Math.max(0.001, envelope.decay));
}

export function releaseEnvelope(
  gainParam: AudioParam,
  context: BaseAudioContext,
  releaseSeconds = DEFAULT_RELEASE,
  when = context.currentTime
): void {
  gainParam.cancelScheduledValues(when);
  gainParam.setTargetAtTime(MIN_GAIN, when, Math.max(0.001, releaseSeconds));
}
